// `useInstalacion()`: en qué situación está este aparato respecto a la app
// instalada · DIRECTRIZ-PWA F1 (DISENO-F1 §9.2).
//
//   instalada   ← estaInstalada()
//   instalable  ← hay evento de instalación (Android/Chrome, Chrome de escritorio)
//   iphone      ← esIOS() y no instalada
//   sin-boton   ← táctil sin evento y no iOS (Firefox, Samsung Internet…)
//   escritorio  ← lo demás
import { useCallback, useEffect, useState } from 'react';
import { useEstadoWorker } from './estadoWorker';
import {
  eventoDeInstalacion, estaInstalada, esIOS, esTactil, instalar as lanzar,
  suscribir, pedirPersistencia, persistenciaRecordada,
} from './instalacion';

export function calcularEstado() {
  if (estaInstalada()) return 'instalada';
  if (eventoDeInstalacion()) return 'instalable';
  if (esIOS()) return 'iphone';
  if (esTactil()) return 'sin-boton';
  return 'escritorio';
}

export function useInstalacion({ pedir = true } = {}) {
  const [estado, setEstado] = useState(calcularEstado);
  const [persistente, setPersistente] = useState(persistenciaRecordada);
  const worker = useEstadoWorker();

  const recalcular = useCallback(() => setEstado(calcularEstado()), []);

  useEffect(() => {
    const soltar = suscribir(recalcular);
    const mm = typeof matchMedia === 'function' ? matchMedia('(display-mode: standalone)') : null;
    mm?.addEventListener?.('change', recalcular);
    window.addEventListener('tego:worker', recalcular);
    return () => {
      soltar();
      mm?.removeEventListener?.('change', recalcular);
      window.removeEventListener('tego:worker', recalcular);
    };
  }, [recalcular]);

  useEffect(() => {
    if (!pedir) return undefined;
    let vivo = true;
    pedirPersistencia().then((r) => { if (vivo) setPersistente(r); });
    return () => { vivo = false; };
  }, [pedir]);

  const instalar = useCallback(async () => {
    const r = await lanzar();
    recalcular();
    return r;
  }, [recalcular]);

  return { estado, instalar, worker, persistente, recalcular };
}
